<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="masterToggle()"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
      >
      </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (dblclick)="$event.stopPropagation()"
        (change)="selection.toggle(item)"
        [checked]="selection.isSelected(item)"
      >
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header="lastName"> {{ 'common.name' | t }} </mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.fullName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="firstName">
    <mat-header-cell *matHeaderCellDef mat-sort-header="firstName"> {{ 'common.firstName' | t }} </mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.firstName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastName">
    <mat-header-cell *matHeaderCellDef mat-sort-header="lastName"> {{ 'common.lastName' | t }} </mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.lastName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="company">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.company' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.company }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="role">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.role' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.role }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="nominated_by">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'users.requestAccess.nominatedBy' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.nominatedBy }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="notes">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.notes' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.notes }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="email">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.email' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.email }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="mobilePhone">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.mobilePhone' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.mobilePhone | fsPhoneNumber }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="title">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.title' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.title }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="badge">
    <mat-header-cell class="hidden-mobile" *matHeaderCellDef mat-sort-header>
      {{ 'common.badge' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-mobile" *matCellDef="let item">
      <span class="text-truncate">{{ item.badge }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="callSign">
    <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'common.callSign' | t }} </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <div class="text-truncate">
        <sn-call-sign-quick-change [user]="item" [(team)]="item.team" [(callSign)]="item.callSign">
        </sn-call-sign-quick-change>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="lastLogin">
    <mat-header-cell class="hidden-tablet" *matHeaderCellDef mat-sort-header>
      {{ 'common.lastActive' | t }}
    </mat-header-cell>
    <mat-cell class="hidden-tablet" *matCellDef="let item">
      <span class="text-truncate"><sn-user-last-active [user]="item"></sn-user-last-active></span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="owner">
    <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-owner [object]="item"></sn-object-owner>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="sharing">
    <mat-header-cell *matHeaderCellDef>{{ 'common.sharing' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-share-status [object]="item"></sn-object-share-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    [@snFadeIn]
    [@snFadeOut]
    [class.mat-row--selected]="selection?.isSelected(item)"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
